var linkedin = "https://shopfront-cdn.tekoapis.com/static/c45c0304dbe3b0ac.svg";

export { linkedin as default };
